import React from 'react';
import { useSelector } from 'react-redux';
import { Grid, Typography, Hidden } from '@material-ui/core';
import { Special } from 'components/SpecialListView';
import WkblVideoVO from 'commons/vo/WkblVideoVO';
import clsx from 'clsx';
import { RootState } from 'redux/reducers/type';
import { useStyles } from 'components/AssetListView/styles';

function SpecialListView() {
  const { specialVideoList } = useSelector((state: RootState) => state.wkblSpecialVideo);
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Hidden mdDown>
        <div className={clsx(classes.headerContainer, classes.row)}>
          <span className={clsx(classes.headerColumn, classes.seasonContainer)}>시즌</span>
          <span className={clsx(classes.headerColumn, classes.typeContainer)}>구분</span>
          <span className={clsx(classes.headerColumn, classes.titleContainer)}>콘텐츠 명</span>
          <span className={clsx(classes.headerColumn, classes.teamContainer)}>홈팀</span>
          <span className={clsx(classes.headerColumn, classes.teamContainer)}>원정팀</span>
          <span className={clsx(classes.headerColumn, classes.gameDateContainer)}>경기 일자</span>
          <span className={clsx(classes.headerColumn, classes.menuContainer)}>메뉴</span>
        </div>
      </Hidden>
      {specialVideoList.map((specialVideo: WkblVideoVO, index: number) => (
        <Special key={`${specialVideo.id}_${index}`} specialVideo={specialVideo} index={index} />
      ))}
    </div>
  );
}

export default SpecialListView;
